import { t } from './i18n';

export interface PasswordStrength {
  /** 0..4 */
  score: number;
  label: string;
  /** ¿Cumple el mínimo aceptable para registrarse? */
  ok: boolean;
  /** Mensaje de ayuda cuando aún no es aceptable (o vacío). */
  hint: string;
}

/**
 * Fuerza de contraseña, simple y sin dependencias.
 * Mínimo exigido: >= 8 caracteres y combinación de letras + números.
 */
export function passwordStrength(pw: string): PasswordStrength {
  const longEnough = pw.length >= 8;
  const hasLetter = /[a-zA-Z]/.test(pw);
  const hasNumber = /\d/.test(pw);
  const hasSymbol = /[^a-zA-Z0-9]/.test(pw);
  const hasUpper = /[A-Z]/.test(pw);

  let score = 0;
  if (longEnough) score++;
  if (hasLetter && hasNumber) score++;
  if (hasSymbol) score++;
  if (hasUpper && pw.length >= 12) score++;

  const ok = longEnough && hasLetter && hasNumber;

  let hint = '';
  if (pw.length > 0 && !longEnough) hint = t('register.password.tooShort');
  else if (pw.length > 0 && !(hasLetter && hasNumber)) hint = t('register.password.needMix');

  let label = t('register.password.weak');
  if (score >= 3) label = t('register.password.strong');
  else if (score === 2) label = t('register.password.fair');

  return { score, label, ok, hint };
}
